// DayCard.jsx
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classes from '../FitnessPreview.module.scss'
import StopwatchSvg from './StopwatchSvg'
import ArrowIconSvg from './RestDayCardArrowIconSvg'
import PlayIconSvg from './VideoPlayIconSvg'
import VideoTagSvg from './VideoTagSvg'
import { PROGRAM_PLAN_CONTENT_TYPE_LABELS } from '../../../constants'
import {Duration} from 'luxon';

const DEFAULT_DURATION = 30;
const VIDEO_CONTENT_LABEL = "Video";
const DayCard = ({ index, day, isRest = false }) => {

    if (!day) {
        return null;
    }
    const { instance } = day;
    let imageSrc = "";

    if (instance && !isRest) {
        if (instance.file && instance.file.link) {
            imageSrc = instance.file.link;
        } else if (instance.imageURL) {
            imageSrc = instance.imageURL || "";
        } else {
            imageSrc = instance.imageUrl || "";
        }
    }


    const duration = Math.floor(Duration.fromMillis(instance?.duration || 0).as('minutes')) || DEFAULT_DURATION;
    const cookingTime = instance?.cookingTime;
    const name = instance ? instance.name : "";
    const isVideo = PROGRAM_PLAN_CONTENT_TYPE_LABELS[day.contentType] === VIDEO_CONTENT_LABEL;

    return !isRest ? (
        <div className={classes.dayCard}>
            <div className={classes.imgOverlay}>
                <img width={100}
                    src={imageSrc}
                    className={classes.dayImage}
                    alt={name} />
                {isVideo ? <PlayIconSvg /> : null}
            </div>

            <div className={classes.dayInfo}>
                <div className={classes.dayLabel}>Day {index + 1}</div>
                <div className={classes.center}>
                    <div className={`${classes.dayDescription}` + (isVideo ? ` ${classes.hasTag}` : '')}>{name}</div>
                    {isVideo && <VideoTagSvg />}
                </div>
                <div className={classes.durationOptionalContainer}>
                    {(duration !== undefined || cookingTime !== undefined) && (
                    <div className={classes.dayDuration}>{cookingTime !== undefined ? cookingTime : duration}m</div>)}
                    {day.isOptional && <div className={classes.dayDuration}>Optional</div>}
                </div>
            </div>
        </div>
    ) : (
        <div className={classes.restCardContainer}>
            <div className={classes.restCard}>
                <StopwatchSvg />
                <div className={classes.restInfo}>
                    <div className={classes.restDayLabel}> Day {index + 1}</div>
                    <div className={classes.restDayDescription}>Rest Day</div>
                </div>
            </div>
            <ArrowIconSvg />
        </div>

    )
}

DayCard.propTypes = {
    index: PropTypes.number.isRequired,
    day: PropTypes.shape({
        isRest: PropTypes.bool,
        isOptional: PropTypes.bool,
        contentType: PropTypes.string,
        instance: PropTypes.shape({
            name: PropTypes.string,
            duration: PropTypes.string,
            file: PropTypes.shape({
                link: PropTypes.string,
                name: PropTypes.string,
                fileKey: PropTypes.string,
            }),
            imageURL: PropTypes.string,
            imageUrl: PropTypes.string,
        }),
    }).isRequired,
}

export default DayCard
